<template>
  <div ref="container">
    <a-drawer
      :title="title"
      width="87vw"
      :visible="visible"
      :maskClosable="false"
      :mask="false"
      :confirmLoading="confirmLoading"
      :wrapClassName="wrapClassNameInfo()"
      @ok="handleOk"
      @close="handleCancel"
      cancelText="取消"
      okText="保存"
      :destroyOnClose="true">
      <!-- <div class="table-page-search-wrapper">
        <a-button @click="handleDownload">下载</a-button>
      </div> -->
      <a-row :gutter="24">
      <a-col :md="24">
        <a-card>
          <!-- 查询区域 -->
          <!-- <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="24">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-col :md="6" :sm="24">
                      <a-button type="primary" @click="searchQuery">查询</a-button>
                      <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    </a-col>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div> -->
          

          <!-- table区域-begin -->
          <div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="uuid"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="handleMakeCodeList(record,ruleId)">生码列表</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.uuid)">
                  <a>删除</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleDownload(record)">下载</a>
              </span>
              <!-- 状态渲染模板 -->
              <template slot="customRenderFlag" slot-scope="enabled">
                <a-tag v-if="enabled==1" color="green">启用</a-tag>
                <a-tag v-if="enabled==0" color="orange">禁用</a-tag>
              </template>
            </a-table>
          </div>
        </a-card>
      </a-col>
    </a-row>
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
    </a-drawer>

    <makeCodeRecordList-modal2 ref="modalForm" @ok="modalFormOk"></makeCodeRecordList-modal2>
  </div>
</template>
<script>
  import pick from 'lodash.pick'
  import { makeCodeRecordModalList } from '@/api/identifierCode/identifierCode'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {autoJumpNextInput} from "@/utils/util"
  import { getFileAccessHttpUrl } from '@/api/manage';
  import {mixinDevice} from '@/utils/mixin'
  import JSelectMultiple from '@/components/jeecg/JSelectMultiple'
  import { downloadCodeList } from '@/api/api'
  import MakeCodeRecordListModal2 from './makeCodeRecordListModal.vue' // 引入 生码列表抽屉
  export default {
    name: "MakeCodeRecordModal",
    mixins: [mixinDevice, JeecgListMixin],
    components: {
      JSelectMultiple,
      MakeCodeRecordListModal2
    },
    data () {
      return {
        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },

        // 查询条件
        queryParam: {
          ruleId: this.ruleId
        },
        getBatchId: null,
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width: '5%',
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '30%',
            align:"center",
            scopedSlots: { customRender: 'action' },
          },
          {title: '生码时间 ', dataIndex: 'createTime', width: '40%',align:"center",},
          {title: '数量 ', dataIndex: 'number', width: '20%',align:"center",},
        ],
        url: {
          list: "/codeRules/fzIdcodeBatch/list",
          delete: "/codeRules/fzIdcodeBatch/delete",
          deleteBatch: "/codeRules/fzIdcodeBatch/deleteBatch"
        },
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
              return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{

        },
        ruleId: null,
        downLoadId : null,
        downloadCounter: 1
      }
    },
    created () {
    },
    methods: {
      add (qve) {
        this.downLoadId = qve
        console.log(qve,'add++++++++++++++++++++++++qve================')
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
        this.visible = true;
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.id){
          this.jselectMultiple.value = record.pushBtn
        } else {
          this.jselectMultiple.value = ''
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'number', 'name', 'parentNumber', 'parentName', 'url', 'component', 'sort', 'pushBtn', 'icon', 'enabled'))
          autoJumpNextInput('functionModal')
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            formData.pushBtn = this.jselectMultiple.value
            let obj;
            if(!this.model.id){
              obj=addFunction(formData);
            }else{
              obj=editFunction(formData);
            }
            obj.then((res)=>{
              if(res.code === 200){
                that.$emit('ok');
              }else{
                that.$message.warning(res.data.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      // 下载
      async handleDownload(record){
        const params= {
          id: record.uuid
        }
        const res = await downloadCodeList(params)
        const blob = res instanceof Blob ? res : new Blob([res]);
        // 创建一个指向 Blob 的下载链接
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `下载${this.downloadCounter}.txt`; // 设置下载的文件名
        document.body.appendChild(a);
        a.click(); // 触发下载
        document.body.removeChild(a);
        // 递增计数器
        this.downloadCounter++;
        // if ( res.code == 200 && res.success == true ) {
        //   // 如果 response 不是 Blob，则转换为 Blob（这里假设是 ArrayBuffer）
          
        //   // this.$message.success(res.message);
        //   // 得到文件流进行下载
        //   // const url = window._CONFIG['domianURL'] + '/sys/common/download';
        //   // const method = 'get';
        //   // const params = {
        //   //     data: {
        //   //         fileName: encodeURI(res.result.fileName),
        //   //         realName: res.result.realName
        //   //     },
        //   //     responseType: 'blob'
        //   // };
        //   // downloadFile(url, params, method).then(data => {})
        // } else {
        //   this.$message.warning(res.message);
        // }
      },
      handleCancel () {
        this.close()
      },
      // 其他方法...
      showTotal(total) {
          return `共 ${total} 条`;
      },
      getList(qve) {
        console.log(qve,'这里的qve的值==========================')
        this.queryParam.ruleId = qve.uuid
        this.ruleId = qve.uuid
        let pageNo = this.ipagination.current
        let pageSize = this.ipagination.pageSize
        makeCodeRecordModalList({ruleId: qve.uuid, pageNo: pageNo, pageSize: pageSize})
        .then(res => {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.getBatchId = res.result.records[0].uuid
        })
      }
    }
  }
</script>
<style scoped>

</style>